import { Api, ApiResponse } from "common";
import { ActiveBrandsResponse } from "./types";

const getActiveBrands = (): ApiResponse<ActiveBrandsResponse> => {
  return Api.get("api/ecomm/brands/active_brands/get");
};

export const BrandsApi = {
  getActiveBrands,
};
